import { Badge, Text } from '@mantine/core';

interface StatusBadgeProps {
  status: string | undefined;
}

const STATUS_COLORS: Record<string, string> = {
  active: 'green',
  enabled: 'green',
  disabled: 'red',
  suspended: 'red',
  inactive: 'gray',
  pending: 'yellow',
  succeeded: 'green',
  running: 'blue',
  failed: 'red',
  partial: 'orange',
  cancelled: 'gray',
  queued: 'gray',
  cancelling: 'orange',
};

export function StatusBadge({ status }: StatusBadgeProps) {
  return status ? (
    <Badge color={STATUS_COLORS[status.toLowerCase()] ?? 'gray'} variant="light">
      {status}
    </Badge>
  ) : (
    <Text size="sm" color="dimmed">
      —
    </Text>
  );
}
